export default {
    title: 'Favourites',
    selected: 'selected',
    remove: 'Remove',
    allCategories: 'All categories',
    product: {
        addToCart: 'Add to cart',
        notifyMe: 'Notify me',
        removeSuccessMessage: 'Product has been removed successfully from your wish list.',
        removeMultipleSuccessMessage: 'Products have been removed successfully from your wish list.'
    }
}